import {
  TabPanel as HeadlessTabPanel,
  type TabPanelProps as HeadlessTabPanelProps,
} from "@headlessui/react";
import { type ElementType } from "react";

type TabPanelProps<TTag extends ElementType = "div"> =
  HeadlessTabPanelProps<TTag>;

export default function TabPanel<TTag extends ElementType = "div">(
  props: TabPanelProps<TTag>,
) {
  return <HeadlessTabPanel {...(props as any)} />;
}
